import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, Row } from 'react-bootstrap'

import styles from './style.module.scss'
import Layout from '@shared-components/layout'
import Error from '@shared/components/error'

const AboutUs = ({ seoData }) => {
  return (
    <Layout data={{ oSeo: seoData }}>
      <section className={`${styles.bannerSection}`}>
        <Container>
          <div className={`${styles.content} d-flex align-items-center justify-content-center`}>
            <h1 className="mb-0">About Us</h1>
          </div>
        </Container>
      </section>
      <section className={`${styles.bannerSection1} common-section text-center bg-light`}>
        <Container>
          <Row>
            <Col md={4}>
              <div className="common-box mt-2 mb-2">
                <h2 className="mb-2 mt-2">100000+</h2>
                <p className="big-text mb-2">POSTS</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="common-box mt-2 mb-2">
                <h2 className="mb-2 mt-2">100+</h2>
                <p className="big-text mb-2">AUTHORS</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="common-box mt-2 mb-2">
                <h2 className="mb-2 mt-2">100000+</h2>
                <p className="big-text mb-2">PAGE VIEWS DAILY</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={`${styles.bannerSection1} common-section text-center`}>
        <Container>
          <Row className="justify-content-center ">
            <Col md={10} lg={8}>
              <p className="big-text">
                We value our readers and encourage your active participation. You can comment on articles, share your views, and even submit your stories or tips. Your voice matters at Everyday Times. We are committed to upholding the highest standards of journalistic integrity. Our news articles are meticulously researched, and we present them without bias, giving you the information you need to form your own opinions. Whether it is breaking news, in-depth analyses, or human-interest stories, Everyday Times offers a wide range of content to keep you informed and engaged.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={`${styles.bannerSection1} common-section text-center bg-light`}>
        <Container>
          <Row className="justify-content-center ">
            <Col md={10} lg={8}>
              <h2>What is Everyday Times</h2>
              <p className="big-text">
                Welcome to Everyday Times, your trusted source for daily news and information from around the world. We are a dedicated team of journalists and writers committed to delivering timely, accurate, and engaging news stories that matter to you. At Everyday Times, we strive to keep you informed about the latest developments, inspiring stories, and essential insights that shape our ever-changing world.
              </p>
              <p className="big-text">Our team of reporters and writers comes from diverse backgrounds and locations, allowing us to provide a global perspective on the issues that matter most.</p>
              <p className="big-text">
                Everyday Times is more than just a news website; its a commitment to the truth, accuracy, and the power of knowledge. We understand the profound impact that reliable journalism can have on society, and we take our responsibility seriously. We are dedicated to providing you with the information you need to navigate our complex world, understand its challenges, and appreciate its beauty.
              </p>
              <h2>Our USP</h2>
              <p className="big-text">
                Everyday Times was founded with a simple yet profound mission: to provide you with reliable news and insights that empower you to make informed decisions, understand the world better, and stay connected to the events that impact your life. We believe that well-informed individuals are essential for a vibrant and healthy society, and we are here to fulfill this critical role.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={`${styles.bannerSection1} common-section text-center`}>
        <Container>
          <Row className="justify-content-center ">
            <Col md={10} lg={8}>
              <h2>The Everyday Times Pillars</h2>
              <p className="big-text">At Everyday Times, we take pride in our dedicated and passionate team of journalists, writers, editors, and professionals who work tirelessly to bring you the latest news and stories from around the world. Our team is our most valuable asset, and their commitment to quality journalism is what sets us apart.</p>
              <p className="big-text">We are proud to be a diverse and inclusive team, with members hailing from different backgrounds, cultures, and regions, giving us a truly global perspective. Our collective experience and dedication to responsible journalism make us a force to be reckoned with in the world of news.</p>
              <p className="big-text">At Everyday Times, we foster a culture of collaboration, creativity, and continuous learning. We believe in the power of teamwork and the importance of nurturing each individual potential. Our team is driven by a common goal: to provide you with news and stories that matter, keeping you informed and inspired.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}
AboutUs.propTypes = {
  seoData: PropTypes.object
}
export default Error(AboutUs)

export async function getServerSideProps({ res, resolvedUrl, query }) {
  const { checkRedirectionStatus, handleApiError } = await import('@shared/utils')
  try {
    res.setHeader('Cache-Control', 'public, max-age=420')
    const url = resolvedUrl?.split('?')[0]

    const [graphql, articleQuery] = await Promise.all([import('@shared-components/queryGraphql'), import('@graphql/article/article.query')])
    const { data: seoData } = await graphql.default(articleQuery.GET_ARTICLE_ID, { input: { sSlug: url.replaceAll('/', '') || '' } })

    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData, query?.amp)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj

    return {
      props: {
        seoData: seoData?.getSeoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
